import * as Types from '../Constants/AllConstants';

// Get all news (paged)
export const GetAllNewsReducer = (
  state = { news: [], pages: 0, page: 0 },
  action
) => {
  switch (action.type) {
    case Types.NEWS_LIST_REQUEST:
      return { ...state, loading: true };
    case Types.NEWS_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        news: action.payload.content,
        pages: action.payload.totalPages,
        page: action.payload.number,
      };
    case Types.NEWS_LIST_FAIL:
      return { loading: false, error: action.payload };
    case Types.NEWS_LIST_RESET:
      return { news: [] };
    default:
      return state;
  }
};

// Get news details
export const NewsDetailsReducer = (state = { news: {} }, action) => {
  switch (action.type) {
    case Types.NEWS_DETAILS_REQUEST:
      return { loading: true };
    case Types.NEWS_DETAILS_SUCCESS:
      return { loading: false, news: action.payload };
    case Types.NEWS_DETAILS_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

// Create news
export const CreateNewsReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.NEWS_CREATE_REQUEST:
      return { loading: true };
    case Types.NEWS_CREATE_SUCCESS:
      return { loading: false, success: true, news: action.payload };
    case Types.NEWS_CREATE_FAIL:
      return { loading: false, error: action.payload };
    case Types.NEWS_CREATE_RESET:
      return {};
    default:
      return state;
  }
};

// Update news
export const UpdateNewsReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.NEWS_UPDATE_REQUEST:
      return { loading: true };
    case Types.NEWS_UPDATE_SUCCESS:
      return { loading: false, success: true, news: action.payload };
    case Types.NEWS_UPDATE_FAIL:
      return { loading: false, error: action.payload };
    case Types.NEWS_UPDATE_RESET:
      return {};
    default:
      return state;
  }
};

// Delete news
export const DeleteNewsReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.NEWS_DELETE_REQUEST:
      return { loading: true };
    case Types.NEWS_DELETE_SUCCESS:
      return { loading: false, success: true };
    case Types.NEWS_DELETE_FAIL:
      return { loading: false, error: action.payload };
    case Types.NEWS_DELETE_RESET:
      return {};
    default:
      return state;
  }
};

// Publish news
export const PublishNewsReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.NEWS_PUBLISH_REQUEST:
      return { loading: true };
    case Types.NEWS_PUBLISH_SUCCESS:
      return { loading: false, success: true, news: action.payload };
    case Types.NEWS_PUBLISH_FAIL:
      return { loading: false, error: action.payload };
    case Types.NEWS_PUBLISH_RESET:
      return {};
    default:
      return state;
  }
};

// Get news by status
export const GetNewsByStatusReducer = (
  state = { news: [], pages: 0, page: 0 },
  action
) => {
  switch (action.type) {
    case Types.NEWS_BY_STATUS_REQUEST:
      return { ...state, loading: true };
    case Types.NEWS_BY_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        news: action.payload.content,
        pages: action.payload.totalPages,
        page: action.payload.number,
      };
    case Types.NEWS_BY_STATUS_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

// Get news by category
export const GetNewsByCategoryReducer = (
  state = { news: [], pages: 0, page: 0 },
  action
) => {
  switch (action.type) {
    case Types.NEWS_BY_CATEGORY_REQUEST:
      return { ...state, loading: true };
    case Types.NEWS_BY_CATEGORY_SUCCESS:
      return {
        ...state,
        loading: false,
        news: action.payload.content,
        pages: action.payload.totalPages,
        page: action.payload.number,
      };
    case Types.NEWS_BY_CATEGORY_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

// Get featured news
export const GetFeaturedNewsReducer = (
  state = { news: [], pages: 0, page: 0 },
  action
) => {
  switch (action.type) {
    case Types.NEWS_FEATURED_REQUEST:
      return { ...state, loading: true };
    case Types.NEWS_FEATURED_SUCCESS:
      return {
        ...state,
        loading: false,
        news: action.payload.content,
        pages: action.payload.totalPages,
        page: action.payload.number,
      };
    case Types.NEWS_FEATURED_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};